import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad867776"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["name"]
const _hoisted_3 = { class: "block text-sm text-red-400" }

import { onMounted, ref, watch } from "vue"
  import { useField } from "vee-validate"
  import Editor from "@toast-ui/editor"
  import "@toast-ui/editor/dist/toastui-editor.css"

  interface Props {
    modelValue: string
    name: string
    placeholder?: string
    max?: number
    height?: string
    toolbar?: Array<string[]>
    hideToolbar?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TextAreaTemplate',
  props: {
    modelValue: null,
    name: null,
    placeholder: null,
    max: null,
    height: null,
    toolbar: null,
    hideToolbar: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props as {
    modelValue: string
    name: string
    placeholder?: string
    max?: number
    height?: string
    toolbar?: Array<string[]>
    hideToolbar?: boolean
  }

  
  const { value, errorMessage } = useField(props.name)
  
  const textarea = ref<HTMLElement | null>(null)
  let editor: Editor | null = null
  const currentLength = ref<number>(0)

  const extractContent = (stringHTML: string) => {
    const span = document.createElement("span")
    span.innerHTML = stringHTML
    return span.textContent || span.innerText
  }

  const onEditorChanges = () => {
    if (editor) {
      const mdText = extractContent(editor.getHTML())
      const content = mdText.replace(props.placeholder || "Type here ...", "")
      if ((props.max && mdText.length <= props.max) || !props.max) emit("update:modelValue", content.length ? editor.getHTML() : "")
      currentLength.value = content.length ? 0 : editor.getHTML().length
      value.value = content.length ? editor.getHTML() : ""
    }
  }

  const initEditor = () => {
    if (textarea.value && !editor) {
      editor = new Editor({
        el: textarea.value as HTMLElement,
        height: props.height || "250px",
        initialEditType: "wysiwyg",
        usageStatistics: false,
        autofocus: false,
        initialValue: props.modelValue || "",
        placeholder: props.placeholder || "Type here ...",
        previewStyle: "tab",
        hideModeSwitch: true,
        frontMatter: true,
        toolbarItems: props.toolbar || [
          ["bold", "italic", "strike"],
          ["hr", "quote"],
        ],
        events: {
          change: onEditorChanges,
        },
      })
    }
  }

  onMounted(() => {
    initEditor()
    currentLength.value = props.modelValue.length
  })

  watch(textarea, initEditor)
  watch(value, (val) => {
    if (val && editor) {
      editor.setHTML(val.replace(/\s+/g, "&nbsp;"), false)
    } else editor.setHTML("", false)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "textarea",
      ref: textarea,
      class: _normalizeClass(["w-full", { 'hide-editor-toolbar': __props.hideToolbar }])
    }, null, 2),
    (props.max)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(currentLength.value) + "/" + _toDisplayString(props.max), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      name: props.name,
      type: "text",
      class: "hidden"
    }, null, 8, _hoisted_2), [
      [_vModelText, _unref(value)]
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(errorMessage)), 1)
  ], 64))
}
}

})